import { render, staticRenderFns } from "./GenusIndexCreateComponent.vue?vue&type=template&id=88369150&scoped=true&"
import script from "./GenusIndexCreateComponent.vue?vue&type=script&lang=js&"
export * from "./GenusIndexCreateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88369150",
  null
  
)

export default component.exports